import React from 'react'
import LuxPlusDestinationCarousel from './LuxPlusDestinationCarousel'
import LuxPlusRenewalBonusBanner from './LuxPlusRenewalBonusBanner'
import LuxPlusLandingOfferCarousels from './LuxPlusLandingOfferCarousels'
import LuxPlusLandingFaqSection from './LuxPlusLandingFaqSection'
import LuxPlusLandingPartnerOffersSection from './LuxPlusLandingPartnerOffersSection'
import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { useAppSelector } from 'hooks/reduxHooks'
import { getIsLuxPlusMemberNearingRenewal } from 'selectors/luxPlusSelectors'

function LuxPlusLoggedInOffersTabSection() {
  // Within 30 days of renewal the renewal bonus surfaces above the offer carousels;
  // otherwise it sits below them.
  const isNearingRenewal = useAppSelector(getIsLuxPlusMemberNearingRenewal)

  return (<>
    <VerticalSpacer gap={40} />
    <LuxPlusDestinationCarousel />
    {isNearingRenewal && <LuxPlusRenewalBonusBanner />}
    <LuxPlusLandingOfferCarousels />
    {!isNearingRenewal && <LuxPlusRenewalBonusBanner />}
    <LayoutContainer>
      <LuxPlusLandingPartnerOffersSection />
    </LayoutContainer>
    <LuxPlusLandingFaqSection />
  </>)
}

export default LuxPlusLoggedInOffersTabSection
